import {
  BannerScriptExecutionTiming,
  CampaignGamBannerAssetInfo,
} from '../Api/campaigns'
import { gamBannerSizes } from '../Constants/GamBannerSizes'

export function migrateToGamBanner(
  bannerScript: string,
  executionTiming: BannerScriptExecutionTiming
): CampaignGamBannerAssetInfo {
  if (!isGPTBanner(bannerScript)) {
    throw new Error('Not a GPT banner')
  }
  const normalizedBannerScript = normalize(bannerScript)
  const slotId = extractSlotId(normalizedBannerScript)
  const sizes = extractSizes(normalizedBannerScript)
  const allowedSizes = sizes.filter((size) => gamBannerSizes.includes(size))
  console.log('migrateToGamBanner', {
    normalizedBannerScript,
    slotId,
    sizes,
    allowedSizes,
    executionTiming,
  })
  return {
    slotId,
    sizes: allowedSizes,
    autoRefreshEverySeconds: undefined,
    executionTiming,
  }
}

function isGPTBanner(bannerScript: string): boolean {
  return (
    /(googletagservices.com|doubleclick.net)(\/tag\/js\/gpt|\/dbm\/ad)/.test(
      bannerScript
    ) || /googletag/.test(bannerScript)
  )
}

function normalize(bannerScript: string): string {
  return bannerScript
    .replace(/'/g, '"')
    .replace(/[\n\r]/g, '')
    .replace(/\s+/g, '')
}

function extractSlotId(bannerScript: string): string {
  const anythingButQuotesAsFirstArgumentOfDefineSlot = /defineSlot\("([^"]+)"/
  const slotIdMatch = bannerScript.match(
    anythingButQuotesAsFirstArgumentOfDefineSlot
  )
  if (!slotIdMatch) {
    throw new Error('Cannot extract slot Id')
  }
  return slotIdMatch[1]
}

function extractSizes(bannerScript: string): string[] {
  const anythingButParanthesisAsSecondParameterOfDefineSlot =
    /defineSlot\("[^"]+",\[([^)]+)\]/
  const slotIdMatch = bannerScript.match(
    anythingButParanthesisAsSecondParameterOfDefineSlot
  )
  try {
    const rawSizes = JSON.parse(`[${slotIdMatch![1]}]`)
    return rawSizes.map((size: any) =>
      Array.isArray(size) ? size.join('x') : size
    )
  } catch (e) {
    throw new Error('Cannot extract sizes')
  }
}
